import { gql } from '@apollo/client';
import type { UUID } from '@cobliteam/common-types';
import graphQLRequester from '../../request/GraphQLRequester';
import { identificationTokenGraphQLToIdentificationToken } from './APITransformer';
import type { IdentificationTokenAPI } from './APITypes';
import type { IdentificationToken } from './Types';

export class GraphQLIdentificationTokenRequester {
  public getIdentificationTokens = (fleetId?: UUID): Promise<IdentificationToken[]> =>
    graphQLRequester
      .query<{ tokens: IdentificationTokenAPI[] }>({
        query: gql`
          query Tokens($fleetId: ID) {
            tokens(input: $fleetId) {
              token_id
              cobli_internal_id
              fleet_id
              driver_id
              associated_to_fleet_at
              status
              token_type
            }
          }
        `,
        variables: { fleetId },
      })
      .then((result) => result.tokens.map(identificationTokenGraphQLToIdentificationToken));

  public deleteToken = (tokenId: string): Promise<void> =>
    graphQLRequester.mutate({
      mutation: gql`
        mutation DeleteToken($id: String!) {
          deleteToken(id: $id)
        }
      `,
      variables: { id: tokenId },
    });
}

export default GraphQLIdentificationTokenRequester;
